export enum XhrResponseType {
    ARRAY_BUFFER = 'arraybuffer',
    TEXT = 'text',
    JSON = 'json',
    DOCUMENT = 'document',
    DEFAULT = '',
}
